export default {
	OVER_80_PERCENT: 'response-limit-over-80-percent',
	PLAN_UPGRADED: 'plan-upgrade-completed',
	RESPONSES_UPGRADED: 'responses-upgrade-completed',
};
